@if (hasActions || orchestrated) {
  @if (visitStatus === "FLOATING" && appointmentStart) {
    <div class="appointment-split-button" [matMenuTriggerFor]="appointmentMenu" [class.disabled]="disabled">
      <div class="appointment-main-content">
        <app-calendar-date-display
          class="appointment-calendar"
          [displayDate]="appointmentStartDate"
          [mini]="true"
        ></app-calendar-date-display>
        <div class="appointment-text">
          <div class="appointment-time floating-appointment">
            Floating Booking
          </div>
          <div class="appointment-date">
            {{ appointmentStart | amDateFormat: "DD/MM/YYYY" }} -
            {{ appointmentEnd | amDateFormat: "DD/MM/YYYY" }}
          </div>
        </div>
      </div>
      <div class="appointment-divider"></div>
      <div class="appointment-dropdown">
        <mat-icon>expand_more</mat-icon>
      </div>
    </div>
  } @else if (appointmentStart) {
    <div class="appointment-split-button" [matMenuTriggerFor]="appointmentMenu" [class.disabled]="disabled">
      <div class="appointment-main-content">
        <app-calendar-date-display
          class="appointment-calendar"
          [displayDate]="appointmentStartDate"
          [mini]="true"
        ></app-calendar-date-display>
        <div class="appointment-text">
          <div class="appointment-time">
            {{ appointmentStart | amDateFormat: "HH:mm" }}
            - {{ appointmentEnd | amDateFormat: "HH:mm" }}
          </div>
          <div class="appointment-date">
            {{
              appointmentStart
                | amCalendar
                  : {
                      sameDay: "[Today]",
                      nextDay: "[Tomorrow]",
                      nextWeek: "dddd",
                      lastDay: "[Yesterday]",
                      lastWeek: "[Last] dddd",
                      sameElse: "DD/MM/YYYY"
                    }
            }}
          </div>
        </div>
      </div>
      <div class="appointment-divider"></div>
      <div class="appointment-dropdown">
        <mat-icon>expand_more</mat-icon>
      </div>
    </div>
  } @else {
    <div
      class="appointment-split-button no-appointment-button"
      [matMenuTriggerFor]="appointmentMenu"
      [class.disabled]="disabled"
    >
      <div class="appointment-main-content">
        <mat-icon
          fontIcon="fa-calendar-plus"
          fontSet="far"
          class="appointment-main-icon"
        ></mat-icon>
        <div class="appointment-text">
          <div class="appointment-time">
            {{ orchestrated ? "Managed in Orchestrator" : "Book Appointment" }}
          </div>
          <div class="appointment-date">No appointment scheduled</div>
        </div>
      </div>
      <div class="appointment-divider"></div>
      <div class="appointment-dropdown">
        <mat-icon>expand_more</mat-icon>
      </div>
    </div>
  }

  <!-- Appointment Context Menu -->
  <mat-menu #appointmentMenu="matMenu">
    @if (orchestrated) {
      <button mat-menu-item disabled>
        <mat-icon>lock</mat-icon>
        <span>Manage in Orchestrator</span>
      </button>
    }
    @if (book) {
      <button mat-menu-item [disabled]="loading" (click)="navigateToBooking()">
        <mat-icon>event</mat-icon>
        <span>Book Appointment</span>
      </button>
    }
    @if (rebook) {
      <button mat-menu-item [disabled]="loading" (click)="navigateToBooking()">
        <mat-icon>event_available</mat-icon>
        <span>Rebook Appointment</span>
      </button>
    }
    @if (refer) {
      <button mat-menu-item (click)="referVisit()" [disabled]="loading">
        <mat-icon>assignment_return</mat-icon>
        <span>Refer Visit</span>
      </button>
    }
    @if (cancel) {
      <button mat-menu-item (click)="cancelVisit()" [disabled]="loading">
        <mat-icon>event_busy</mat-icon>
        <span>Cancel Visit</span>
      </button>
    }
    <button mat-menu-item (click)="bookingHistory()" [disabled]="loading">
      <mat-icon>history</mat-icon>
      <span>Booking History</span>
    </button>
  </mat-menu>
}
